import { render, staticRenderFns } from "./anchor.vue?vue&type=template&id=202382c4&scoped=true&"
import script from "./anchor.vue?vue&type=script&lang=js&"
export * from "./anchor.vue?vue&type=script&lang=js&"
import style0 from "./anchor.vue?vue&type=style&index=0&id=202382c4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "202382c4",
  null
  
)

export default component.exports